import { render, staticRenderFns } from "./channelSkuBLock.vue?vue&type=template&id=5cbf7720&"
import script from "./channelSkuBLock.vue?vue&type=script&lang=ts&"
export * from "./channelSkuBLock.vue?vue&type=script&lang=ts&"
import style0 from "./channelSkuBLock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports